module.exports = __webpack_public_path__ + "img/ekomplet_480.f20dff5f.png";